/**
 * 解析タブの出し分け（§4）。オリゴ→プライマー、環状→マップ、それ以外→検索。
 */

import type { Topology } from '@kensuke/genome-core';

export type AnalysisTab = 'search' | 'restriction' | 'plasmid' | 'primer' | 'crispr' | 'info';

export const SEARCH_EXAMPLE_PATTERNS = ['NGG', 'GAATTC', 'GGATCC'] as const;

export const RESTRICTION_PREFS_KEY = 'gene-analysis-restriction-selection';
export const PRIMER_SETTINGS_KEY = 'gene-analysis-primer-settings';
export const CRISPR_NUCLEASE_KEY = 'gene-analysis-crispr-nuclease';

export function defaultAnalysisTab(length: number, topology: Topology): AnalysisTab {
  if (length > 0 && length <= 60) return 'primer';
  if (topology === 'circular') return 'plasmid';
  return 'search';
}

export function visibleAnalysisTabs(length: number, topology: Topology): AnalysisTab[] {
  const tabs: AnalysisTab[] = ['search', 'restriction'];
  if (topology === 'circular') tabs.push('plasmid');
  if (length >= 18) tabs.push('primer');
  if (length >= 17 && length > 60) tabs.push('crispr');
  tabs.push('info');
  return tabs;
}

export interface SequenceOverlayMark {
  start: number;
  end: number;
  color: string;
  kind: 'search' | 'cut' | 'guide' | 'primer';
  active?: boolean;
}
